import { render } from "./WarenKorbListe.vue?vue&type=template&id=046918f2&scoped=true&ts=true"
import script from "./WarenKorbListe.vue?vue&type=script&lang=ts"
export * from "./WarenKorbListe.vue?vue&type=script&lang=ts"

import "./WarenKorbListe.vue?vue&type=style&index=0&id=046918f2&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046918f2"]])

export default __exports__